<template>
	<div>
		<a :href="'/#/public/task/' + assessment.id" target="_blank">
			<div v-tippy title="Open Task in a new tab." class="goto">
				<i class="fas fa-external-link-alt fa-xl"></i>
			</div>
		</a>
		<div class="container mainContainer">
			<div class="flex-row">
				<h6 class="flex mb-1 mr-1">
					<div @click="goToAssessment(assessment.id)" class="col title theme-login-text">
						<a>{{ assessment.name }}</a>
					</div>
					<!-- <span class="col" v-if="assessment.ref_id">
            •
            <span class="text-muted text-sm">{{ assessment.ref_id }}</span>
          </span> -->
				</h6>
			</div>
			<div class="area col">
				<div class="labels">Grades :</div>
				<div class="grades">
					<span v-for="grade in assessment.grades" :key="grade.id" class="btn-info badge">
						{{ grade.name }}
					</span>
				</div>
			</div>
			<div class="area col">
				<div class="labels">{{ fieldNames.standard }}s :</div>

				<span
					v-for="(standard, i) in assessment.standards"
					:key="i"
					class="btn-success badge theme-accent mr-1"
				>
					{{ standard }}
				</span>
			</div>
			<div class="area col">
				<div class="labels">{{ fieldNames.essential_skill }}s :</div>

				<span v-if="assessment.essential_skills.length == 0" class="btn-warning badge theme-accent mr-1">
					None
				</span>
				<span
					v-for="(eskill, i) in assessment.essential_skills"
					:key="i"
					class="btn-warning badge theme-accent mr-1"
				>
					{{ eskill }}
				</span>
			</div>
			<div class="area col">
				<div class="labels">{{ fieldNames.content_area }}s :</div>

				<span class="btn-danger badge theme-accent mr-1">
					{{ assessment.content_area.name }}
				</span>
				<span
					v-for="(secondary_ca, i) in assessment.secondary_content_area_id"
					:key="i"
					class="btn-danger badge theme-accent mr-1"
				>
					{{ getESName(secondary_ca) }}
				</span>
			</div>

			<div class="area col">
				<div class="labels">Description :</div>

				<span v-tippy :title="assessment.description" v-html="cutText(assessment.description)" class=""></span>
			</div>
		</div>
	</div>
</template>

<style scoped>
.collapsed {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.mainContainer {
	padding: 10px;
}
.title {
	font-size: 22px;
	font-weight: bold;
	cursor: pointer;
}

.labels {
	font-family: "source_sans_prosemibold", Helvetica, Arial, sans-serif;
	color: #000;
	display: block;
	font-size: 12px;
	font-weight: bold;
	margin-bottom: 0.0625rem;
	text-transform: uppercase;
	padding-top: 5px;
}

.goto {
	padding-top: 5px;
	line-height: 12px;
	width: 18px;
	font-size: 11pt;
	font-family: tahoma;
	margin-top: 1px;
	margin-right: 2px;
	position: absolute;
	top: 0;
	right: 0;
}
</style>

<script>
import fs from "@/services/FormatService";

export default {
	name: "PublicAssessmentRow",
	props: ["assessment", "rel", "res", "contentAreas", "fieldNames"],

	data() {
		return {
			fs: fs,
			refID: this.$route.params.tenantID,
			eskills_text: "Essential Skills",
			standards_text: "Standards",
		};
	},
	created() {
		if (this.refID == "CCE") {
			(this.eskills_text = "International Baccalaureate (IB) Standards"),
				(this.standards_text = "Massachusetts Standards");
		}
	},
	watch: {},

	computed: {
		showRel() {
			return !(this.rel == false || isNaN(this.rel));
		},
		showRes() {
			return !(this.res == false || isNaN(this.res));
		},
	},

	computer: {},
	methods: {
		getESName(content_area_id) {
			const found = this.contentAreas.find((element) => element.id == content_area_id);
			if (found) {
				return found.name;
			}

			return "NaN";
		},

		goToAssessment(assessment_id) {
			this.$router.push(`/public/task/${assessment_id}`);
		},
		cutText(text) {
			return text.substr(0, 100) + "...";
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/assessment/PublicAssessmentRow.vue